import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=c0cef3ea&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cef3ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0cef3ea')) {
      api.createRecord('c0cef3ea', component.options)
    } else {
      api.reload('c0cef3ea', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=c0cef3ea&scoped=true&", function () {
      api.rerender('c0cef3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FdOju7M4rfC8/JS/comp/Voucher-Unit.vue"
export default component.exports